/**
* Basic context object that will
* be used to share global state within the app
*/
class AppModel {

    constructor(data, globalScope) {
        if(globalScope) {
            this.GLOBALS = {
                PCH: globalScope.PCH || {},
                LOTTO: globalScope.LOTTO_GLOBALS || {}
            };
            this.user = globalScope.PCHUSER;
        }
        Object.assign(this, data || {});
    }

    // helper method to dot into global objects
    getGlobal(key, defaultVal) {
        var keys = ("" + key).split(".");
        if(keys.length === 0) { 
            return defaultVal;
        }
        var val = this.GLOBALS || {};
        for(var i = 0, n = keys.length; i < n; i++) {
            if(val.hasOwnProperty(keys[i])) {
                val = val[keys[i]];
            }
            else {
                return defaultVal;
            }
        }
        return val;
    }

	get uninav() {
		return this.getGlobal("PCH.uninav.controller");
	}

    static factory(data, globalScope) {
        data = data || {};
        globalScope = globalScope || window;
        return new AppModel(data, globalScope);
    }
}


export default AppModel;
